if (!customElements.get('featured-collection')) {
  class FeaturedCollection extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.querySelectorAll('input[type="radio"][data-target]').forEach(radio => 
        radio.addEventListener('change', () => {
          const target = radio.dataset.target;
          this.querySelectorAll('[data-show]').forEach(el => 
            el.style.display = el.dataset.show === target ? '' : 'none'
          );
        })
      );
    }

  }
  customElements.define('featured-collection', FeaturedCollection);
}